import http from '../../services/http';
import { setActivities } from '../entities/book';
import { updateUser } from '../auth/authReducer';
import axios from 'axios';

import { setActivitiesLoader, setStudentActivityLoader } from '../ui/loaders';
import storage from '../../services/storage';
import { setStudentBlankAnswer } from '../entities/studentBlanks';
import {
  setActivities as setStudentActivites,
  setActivitiesByAssignedDate,
} from '../entities/student';
import { setAllClassSection } from '../entities/student';
import { setUser } from '../auth/authReducer';

const path = 'api/activity';
const path1 = 'api';
const path2 = 'api/dashboard/student';
const path3 = 'api/activityanswer';
const path4 = 'api/settings/student/profile';
const path5 = 'api/class';
const profile_update_path = 'api/settings/student/media';

const byBook = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const res = await http.get({
        url: path + `/bybook/${id}`,
        headers: {},
      });
      dispatch(setActivities(res.data.data));
      dispatch(setActivitiesLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};

const copyBulk = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.post({
        url: path + `/copybulk`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};
const create = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.post({
        url: path + `/addactivity`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};
const edit = ({ id, body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/${id}`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};
const remove = ({ id, body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.delete({
        url: path + `/${id}`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};

const assign = ({ id, body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/assign/${id}`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};

const unassign = ({ id, body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/changeassigneddate/${id}`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};

const filter = ({ bookId, onSuccess, onError, onEnd, queryParams }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/search/${bookId}`,
        queryParams,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      dispatch(setActivitiesLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};

const forStudent = ({ body, onSuccess, onError, id = '', onEnd, classid }) => {
  return async (dispatch, getState) => {
    dispatch(setStudentActivityLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path2 + `/enrolledactivities`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      let actArr = res.data.data.map((e) => e.activities);

      actArr = actArr.flat();
      dispatch(setStudentActivites(actArr));
      dispatch(setActivitiesByAssignedDate(res.data.data));
      dispatch(setStudentActivityLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (err) {
      dispatch(setStudentActivityLoader(false));
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const activityAnswer = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path1 + '/activityanswer',
        headers: {
          'x-auth-token': store.auth.token,
          // "x-auth-token": token,
        },
        body,
      });
      const actArr = res.data?.data?.answers?.map((answer) => answer.studentSelectedBanks).flat();

      // Dispatch only if actArr is not undefined
      if (actArr) {
        dispatch(setStudentBlankAnswer(actArr));
      } else {
        console.warn('No studentSelectedBanks found in the API response.');
      }
      if (onSuccess) onSuccess(res);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const activityInProgress = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path3 + '/progress-questions ',
        headers: {
          'x-auth-token': store.auth.token,
          // "x-auth-token": token,
        },
        body,
      });
      const actArr = res.data?.data?.answers?.map((answer) => answer.studentSelectedBanks).flat();

      // Dispatch only if actArr is not undefined
      if (actArr) {
        dispatch(setStudentBlankAnswer(actArr));
      } else {
        console.warn('No studentSelectedBanks found in the API response.');
      }
      if (onSuccess) onSuccess(res);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const allClasses = ({ body, onSuccess, onError, id = '', onEnd }) => {
  return async (dispatch, getState) => {
    dispatch(setStudentActivityLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path1 + `/class/bystudent`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      dispatch(setStudentActivityLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (err) {
      dispatch(setStudentActivityLoader(false));
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const studentClassSection = ({ body, onSuccess, onError, id = '', onEnd }) => {
  return async (dispatch, getState) => {
    dispatch(setStudentActivityLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path1 + '/studentsection/bystudentsection',
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      dispatch(setAllClassSection(res.data.data));
      dispatch(setStudentActivityLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (err) {
      dispatch(setStudentActivityLoader(false));
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const activityById = ({ onSuccess, onError, id = '', onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/gettingactivitydetails/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      if (onSuccess) onSuccess(res);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const circleActivitites = ({ body, onSuccess, onError, id = '', onEnd }) => {
  return async (dispatch, getState) => {
    // dispatch(setStudentActivityLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path2 + `/gettingAct&Ansforstudent`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      if (onSuccess) onSuccess(res);
    } catch (err) {
      // dispatch(setStudentActivityLoader(false));
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const forStudentClassDetails = ({ body, onSuccess, onError, id = '', onEnd }) => {
  return async (dispatch, getState) => {
    dispatch(setStudentActivityLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path2 + `/enrolledclassdetails/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      dispatch(setStudentActivityLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (err) {
      dispatch(setStudentActivityLoader(false));
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const byBookActivityAnswer = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path3 + `/bybook/${id}`,
        headers: { 'x-auth-token': store.auth.token },
      });
      dispatch(setActivities(res.data.data));
      dispatch(setActivitiesLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};
const studentProfileEdit = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    // dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path4 + `/info`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      const user = res.data.data;
      if (onSuccess) onSuccess(res);
      dispatch(updateUser(user));
      storage.store('user', user);
    } catch (error) {
      if (onError) onError(error);
      // dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      // dispatch(setActivitiesLoader(false));
    }
  };
};
const recievedNotification = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    // dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path4 + `/notifications`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      const user = res.data.data;
      if (onSuccess) onSuccess(res);
      dispatch(updateUser(res.data.data));
      storage.store('user', user);
    } catch (error) {
      if (onError) onError(error);
      // dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      // dispatch(setActivitiesLoader(false));
    }
  };
};
const studentAccountEdit = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    // dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path4 + `/account`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      const user = res.data.data;
      if (onSuccess) onSuccess(res);
      dispatch(updateUser(res.data.data));
      storage.store('user', user);
    } catch (error) {
      if (onError) onError(error);
      // dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      // dispatch(setActivitiesLoader(false));
    }
  };
};
const getClassesActivity = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path2 + `/classonly`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      dispatch(setActivitiesLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};
const getChapterActivity = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path2 + `/chapteronly/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      dispatch(setActivitiesLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};
const filterClassActivity = ({ onSuccess, onError, onEnd, classid, chapterIds }) => {
  return async (dispatch, getState) => {
    dispatch(setStudentActivityLoader(true));
    try {
      const store = getState();
      const res = await http.post({
        url: path2 + `/enrolledactivities?classId=${classid}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body: {
          chapterIds: chapterIds, // match the key name to your API
        },
      });
      dispatch(setStudentActivityLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (err) {
      dispatch(setStudentActivityLoader(false));
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const filterChapterActivity = ({ onSuccess, onError, onEnd, classid, chapterid }) => {
  return async (dispatch, getState) => {
    dispatch(setStudentActivityLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path2 + `/enrolledactivities?classId=${classid}&chapterId=${chapterid}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      dispatch(setStudentActivityLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (err) {
      dispatch(setStudentActivityLoader(false));
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const changeAssignedDate = ({ body, onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    // dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/changeassigneddate/${id}`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      // dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      // dispatch(setActivitiesLoader(false));
    }
  };
};

const setActivitiesSet = ({ body, onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    // dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/setactivityset/${id}`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      // dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      // dispatch(setActivitiesLoader(false));
    }
  };
};
const changeAssignment = ({ body, onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    // dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/changeassignment/${id}`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      // dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      // dispatch(setActivitiesLoader(false));
    }
  };
};

const getStudentSignedUrl =
  ({ body, onSuccess, onError, onEnd }) =>
  async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: profile_update_path,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      const user = res.data.data;
      if (onSuccess) onSuccess(user);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };

const deleteChapter = ({ onSuccess, onError, onEnd, id }) => {
  return async (_, getStore) => {
    try {
      const store = getStore();
      const res = await http.delete({
        url: path1 + `/create/deletechapter/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const blanksShow = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/studentshowedquestion`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};

const assignModeChangeSection = ({ body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path5 + '/assignmodechangesection',
        headers: {
          'x-auth-token': store.auth.token,
          // "x-auth-token": token,
        },
        body,
      });

      if (onSuccess) onSuccess(res);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export {
  byBook,
  copyBulk,
  create,
  edit,
  remove,
  assign,
  unassign,
  filter,
  forStudent,
  allClasses,
  activityById,
  deleteChapter,
  activityAnswer,
  getStudentSignedUrl,
  studentClassSection,
  circleActivitites,
  forStudentClassDetails,
  byBookActivityAnswer,
  studentProfileEdit,
  recievedNotification,
  studentAccountEdit,
  changeAssignedDate,
  getClassesActivity,
  getChapterActivity,
  filterClassActivity,
  filterChapterActivity,
  setActivitiesSet,
  changeAssignment,
  blanksShow,
  assignModeChangeSection,
  activityInProgress,
};
